import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { TextField } from "@material-ui/core";
import type { FC, ChangeEvent } from "react";
import SearhIcon from "../../../../../icons/SearchBlack";
import { useStyles } from "./Search.styles";
import { messages } from "./Search.messages";
import type { ISearchProps } from "./Search.types";

export const Search: FC<ISearchProps> = (props) => {
  const classes = useStyles();
  const intl = useIntl();

  const { value, onChange } = props;

  const placeholder = intl.formatMessage(messages.searchPlaceholder);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <TextField
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      InputProps={{
        startAdornment: <SearhIcon className={classes.adornedEnd} />,
        classes: { ...classes, adornedEnd: undefined },
      }}
    />
  );
};
